import styled from 'styled-components';

const InputErrorMessage = styled.span`
  display: block;
  font-size: 10px;
  color: ${p => p.theme.colors.danger};
`;

export default InputErrorMessage
